
import {
  DOCUMENT_FORM_CLEAR_DOCUMENT, DOCUMENT_FORM_ERROR, DOCUMENT_FORM_SET_DOCUMENT,
  DOCUMENT_FORM_SET_LOADING, DOCUMENT_FORM_UPDATE_COMPANY_DOCUMENT, DOCUMENT_FORM_UPDATE_MACHINE_DOCUMENT, DOCUMENT_FORM_UPDATE_WORKER_DOCUMENT
} from "../actions/documentFormActions";

const INITIAL_STATE = {
    document: null,
    message: null,
    loading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DOCUMENT_FORM_SET_DOCUMENT:
            return { ...state, document: {...action.payload.data}, message: null };
      case DOCUMENT_FORM_UPDATE_WORKER_DOCUMENT:
            return { ...state, document: {...state.document, worker: action.payload.data}, message: null };
      case DOCUMENT_FORM_UPDATE_MACHINE_DOCUMENT:
            return { ...state, document: {...state.document, machine: action.payload.data}, message: null };
      case DOCUMENT_FORM_UPDATE_COMPANY_DOCUMENT:
            return { ...state, document: {...state.document, company: action.payload.data}, message: null };
        case DOCUMENT_FORM_ERROR:
            return { ...state, document: null, message: action.payload };
        case DOCUMENT_FORM_CLEAR_DOCUMENT:
            return { ...state, document: null };
        case DOCUMENT_FORM_SET_LOADING:
            return { ...state, loading: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/DocumentFormReducer.js